import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  photoCard: {
    position: 'relative',
    borderRadius: theme.app.borderRadius.md,
    overflow: 'hidden',
    paddingTop: '100%',
    cursor: 'pointer',
    border: '1px solid #e0e0e0',
    transition: 'transform 0.2s, box-shadow 0.2s',
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
    },
    '&:hover $photoOverlay': {
      opacity: 1
    }
  },

  photoImage: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover'
  },

  photoOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(0,0,0,0.4)',
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
    padding: 8,
    opacity: 0,
    transition: 'opacity 0.2s'
  },

  deleteButton: {
    background: 'rgba(255,255,255,0.9)',
    border: 'none',
    borderRadius: '50%',
    width: 36,
    height: 36,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    transition: 'background 0.2s',
    '&:hover': {
      background: '#fff'
    },
    '& svg': {
      color: theme.palette.primary.main,
      fontSize: 20
    }
  },

  addPhotoCard: {
    borderRadius: theme.app.borderRadius.md,
    paddingTop: '100%',
    position: 'relative',
    border: `2px dashed ${theme.palette.primary.main}`,
    background: '#faf6f3',
    cursor: 'pointer',
    transition: 'background 0.2s, border-color 0.2s',
    '&:hover': {
      background: '#f0e8e2',
      borderColor: '#5c3630'
    }
  },

  addPhotoContent: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8
  },

  addPhotoIcon: {
    color: theme.palette.primary.main,
    fontSize: '36px !important'
  },

  addPhotoText: {
    fontFamily: theme.app.typography.fontFamily.main,
    fontSize: theme.app.typography.paragraph.fontSize,
    fontWeight: 500,
    color: theme.palette.primary.main
  },

  hiddenInput: {
    display: 'none'
  },

  previewBackdrop: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(0,0,0,0.85)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1300,
    padding: 24
  },

  previewContainer: {
    position: 'relative',
    maxWidth: '90vw',
    maxHeight: '90vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },

  previewImage: {
    maxWidth: '100%',
    maxHeight: '85vh',
    objectFit: 'contain',
    borderRadius: theme.app.borderRadius.md
  },

  previewActions: {
    position: 'absolute',
    top: -48,
    right: 0,
    display: 'flex',
    gap: 8
  },

  previewActionButton: {
    background: 'rgba(255,255,255,0.15)',
    border: 'none',
    borderRadius: '50%',
    width: 40,
    height: 40,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    transition: 'background 0.2s',
    '&:hover': {
      background: 'rgba(255,255,255,0.3)'
    },
    '& svg': {
      color: '#fff',
      fontSize: 24
    }
  },

  addPhotoCardDisabled: {
    opacity: 0.5,
    cursor: 'default',
    pointerEvents: 'none' as const
  },

  emptyState: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '40px 0',
    gap: 16,
    '& svg': {
      color: '#bdbdbd',
      fontSize: 64
    }
  },

  emptyText: {
    color: '#000'
  },

  emptyAddButton: {
    borderRadius: theme.app.borderRadius.md,
    width: 160,
    height: 160,
    border: `2px dashed ${theme.palette.primary.main}`,
    background: '#faf6f3',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    gap: 8,
    transition: 'background 0.2s, border-color 0.2s',
    '&:hover': {
      background: '#f0e8e2',
      borderColor: '#5c3630'
    }
  },

  uploadingCard: {
    position: 'relative',
    borderRadius: theme.app.borderRadius.md,
    overflow: 'hidden',
    paddingTop: '100%',
    border: '1px solid #e0e0e0'
  },

  uploadingImage: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    opacity: 0.4
  },

  uploadingOverlay: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    padding: 8,
    background: 'rgba(255,255,255,0.7)'
  },

  uploadingProgressBar: {
    height: 4,
    borderRadius: 2,
    backgroundColor: '#e0d6d0',
    '& .MuiLinearProgress-bar': {
      backgroundColor: theme.palette.primary.main
    }
  },

  uploadingErrorOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 6,
    background: 'rgba(255,255,255,0.85)',
    pointerEvents: 'auto' as const
  },

  uploadingErrorIcon: {
    color: '#f44336',
    fontSize: '32px !important'
  },

  uploadingErrorText: {
    fontFamily: theme.app.typography.fontFamily.main,
    fontSize: theme.app.typography.small.fontSize,
    fontWeight: 500,
    color: '#666',
    textAlign: 'center'
  },

  uploadingRetryButton: {
    background: 'none',
    border: `1px solid ${theme.palette.primary.main}`,
    borderRadius: 6,
    padding: '4px 12px',
    fontFamily: theme.app.typography.fontFamily.main,
    fontSize: theme.app.typography.error.fontSize,
    fontWeight: 500,
    color: theme.palette.primary.main,
    cursor: 'pointer',
    transition: 'background 0.2s',
    '&:hover': {
      background: '#faf6f3'
    }
  }
}))
